/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAnswerDto } from './GetAnswerDto';
import {
    GetAnswerDtoFromJSON,
    GetAnswerDtoFromJSONTyped,
    GetAnswerDtoToJSON,
} from './GetAnswerDto';

/**
 * 
 * @export
 * @interface GetReactionDto
 */
export interface GetReactionDto {
    /**
     * 
     * @type {number}
     * @memberof GetReactionDto
     */
    latencyTime?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetReactionDto
     */
    decisionTime?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetReactionDto
     */
    reactionTime?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetReactionDto
     */
    coreFieldName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetReactionDto
     */
    modeSurvey?: string | null;
    /**
     * 
     * @type {Array<GetAnswerDto>}
     * @memberof GetReactionDto
     */
    answers?: Array<GetAnswerDto> | null;
}

/**
 * Check if a given object implements the GetReactionDto interface.
 */
export function instanceOfGetReactionDto(value: object): value is GetReactionDto {
    return true;
}

export function GetReactionDtoFromJSON(json: any): GetReactionDto {
    return GetReactionDtoFromJSONTyped(json, false);
}

export function GetReactionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReactionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'latencyTime': json['latencyTime'] == null ? undefined : json['latencyTime'],
        'decisionTime': json['decisionTime'] == null ? undefined : json['decisionTime'],
        'reactionTime': json['reactionTime'] == null ? undefined : json['reactionTime'],
        'coreFieldName': json['coreFieldName'] == null ? undefined : json['coreFieldName'],
        'modeSurvey': json['modeSurvey'] == null ? undefined : json['modeSurvey'],
        'answers': json['answers'] == null ? undefined : ((json['answers'] as Array<any>).map(GetAnswerDtoFromJSON)),
    };
}

export function GetReactionDtoToJSON(value?: GetReactionDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'latencyTime': value['latencyTime'],
        'decisionTime': value['decisionTime'],
        'reactionTime': value['reactionTime'],
        'coreFieldName': value['coreFieldName'],
        'modeSurvey': value['modeSurvey'],
        'answers': value['answers'] == null ? undefined : ((value['answers'] as Array<any>).map(GetAnswerDtoToJSON)),
    };
}

